import axios from '@/axios/api.request'

export const save = (from) => axios.request({
    url: '/order/step/save',
    data: from,
    method: 'post'
  })
export const list = (from) => axios.request({
  url: '/order/step/list',
  data: from,
  method: 'post'
})
export const update = (from) => axios.request({
  url: '/order/step/update',
  data: from,
  method: 'post'
})